import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    if (this.element.tomselect) return

    this.#discardStaleWidget()

    const instance = new TomSelect(this.element, this.#settings())

    this.#trackRequired(instance)
    this.#clearQueryAfterSelect(instance)
  }

  disconnect() {
    this.element.tomselect?.destroy()
  }

  // A restored Turbo snapshot brings back the rendered widget markup but not the instance
  // that drove it. The leftover 'tomselected' class used to make us skip initialization,
  // leaving an inert field, so drop the stale markup and rebuild instead.
  #discardStaleWidget() {
    if (!this.element.classList.contains('tomselected')) return

    const wrapper = this.element.nextElementSibling

    if (wrapper?.classList.contains('ts-wrapper')) wrapper.remove()

    this.element.classList.remove('tomselected', 'ts-hidden-accessible')
  }

  // Tom Select clears the typed query only when the dropdown closes, and for a multi-select
  // that is not full it never does (`closeAfterSelect` is unset). The leftover text is then
  // prepended to the next search — typing 'EPAM USA', picking it, then typing 'Netherlands'
  // searches for 'EPAM USANetherlands' and matches nothing.
  #clearQueryAfterSelect(instance) {
    if (!this.element.multiple) return

    instance.on('item_add', () => {
      instance.setTextboxValue('')
      instance.refreshOptions(false)
    })
  }

  // Tom Select hides the original select with `visibility: hidden` but never clears its
  // `required` attribute, so Chrome refuses to submit an empty field and only logs
  // "An invalid form control ... is not focusable" with nothing shown to the user. Move
  // the constraint onto the visible control input, and only while nothing is selected so
  // that a filled field never invalidates the form.
  #trackRequired(instance) {
    if (!instance.isRequired) return

    this.element.required = false

    const syncRequired = () => {
      instance.control_input.required = instance.items.length === 0
    }

    instance.on('change', syncRequired)
    syncRequired()
  }

  #settings() {
    const placeholder = this.data.get("placeholder") || "Please select"

    if (this.element.multiple) {
      return {
        plugins: {
          remove_button: {
            label: '',
            title: 'Remove this item'
          }
        },
        placeholder: placeholder,
        hidePlaceholder: true,
        persist: false
      }
    } else {
      return {
        placeholder: placeholder
      }
    }
  }
}
